module.exports = __webpack_public_path__ + "static/img/defect.f21fef1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Help/defect.gif
// module id = bn/V
// module chunks = 3